module.exports = __webpack_public_path__ + "img/14.29b51219.png";